// BlogSliderSwiper.jsx
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { Card } from "antd";
import { useNavigate } from "react-router-dom";

import "swiper/css";
import "swiper/css/navigation";

const { Meta } = Card;

const truncateToTwoParagraphs = (text) => {
  const paragraphs = text.split("\n").filter((p) => p.trim() !== "");
  if (paragraphs.length <= 2) return text;
  return paragraphs.slice(0, 2).join("\n") + " ...";
};

const BlogSliderSwiper = ({ data }) => {
  const navigate = useNavigate();

  return (
    <div style={{ padding: "0 40px" }}>
      <Swiper
        modules={[Navigation]}
        spaceBetween={24}
        slidesPerView={3}
        navigation
        breakpoints={{
          0: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        }}
      >
        {data.map((item, index) => (
          <SwiperSlide key={index}>
            <Card
              onClick={() => {
                navigate(`/event/${item.id}`);
              }}
              hoverable
              cover={
                <img
                  alt={item.name}
                  src={item.top_image}
                  style={{
                    height: 180,
                    objectFit: "cover",
                    borderTopLeftRadius: 16,
                    borderTopRightRadius: 16,
                    transition: "transform 0.3s",
                  }}
                  className="blog-card-img"
                />
              }
              style={{
                height: 370,
                borderRadius: 16,
                boxShadow: "0 4px 24px rgba(0,0,0,0.10)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                padding: 0,
                margin: "12px 0",
                transition: "box-shadow 0.3s",
                cursor: "pointer",
                overflow: "hidden",
                background: "#fff",
                position: "relative",
              }}
            >
              {/* Tanggal di pojok kanan atas */}
              <div
                style={{
                  position: "absolute",
                  top: 12,
                  right: 16,
                  background: "rgba(0,0,0,0.7)",
                  color: "#fff",
                  padding: "4px 10px",
                  borderRadius: 8,
                  fontSize: 13,
                  zIndex: 2,
                  fontWeight: 500,
                  letterSpacing: 0.5,
                }}
              >
                {/* {new Date(item.create_at).toLocaleDateString()} */}
              </div>
              {/* Tanggal di pojok kanan bawah */}
              <div
                style={{
                  position: "absolute",
                  bottom: 12,
                  right: 16,
                  background: "rgba(0,0,0,0.7)",
                  color: "#fff",
                  padding: "4px 10px",
                  borderRadius: 8,
                  fontSize: 13,
                  zIndex: 2,
                  fontWeight: 500,
                  letterSpacing: 0.5,
                }}
              >
                {/* {new Date(item.create_at).toLocaleDateString()} */}
                {item.created_at}
              </div>
              <Meta
                title={
                  <div
                    style={{
                      fontWeight: 600,
                      fontSize: 18,
                      marginBottom: 10,
                      color: "#222",
                    }}
                  >
                    {item.title}
                  </div>
                }
                description={
                  <div
                    style={{
                      whiteSpace: "pre-wrap",
                      fontSize: 15,
                      color: "#555",
                      marginTop: 6,
                      textAlign: "justify", // rata kanan kiri
                    }}
                  >
                    {truncateToTwoParagraphs(item.description)}
                  </div>
                }
              />
            </Card>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default BlogSliderSwiper;
